var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-link',{attrs:{"type":_vm.type,"underline":_vm.underline,"disabled":_vm.disabled,"href":_vm.href,"icon":_vm.icon,"target":_vm.target}},[_vm._v(" "+_vm._s(_vm.linkText)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }